
import { clamp } from "@lovetoknow/love-utils-js";

export default {
	name: "InputStepper",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		/**
		 * @todo we should find a way to not use this prop,
		 * just use the starting value of the `value` prop
		 * instead for the same purpose. Or make this
		 * component as dumb as possible and just pass data up
		 * and down.
		 */
		defaultCount: {
			required: false,
			type: Number,
			default: null,
		},
		min: {
			required: true,
			type: Number,
		},
		max: {
			required: true,
			type: Number,
		},
		value: {
			required: false,
			type: [String, Number], // string is for empty strings
			default: 0,
		},
		id: {
			required: false,
			type: String,
			default: null,
		},
		disabled: {
			required: false,
			type: Boolean,
			default: false,
		},
	},
	computed: {
		_stepperCount: {
			get() {
				return this.value;
			},
			set(val) {
				// We sanitize the value only if there is a value
				// Also, for comparison only we convert the value to string,
				// so we wont have problems with the fact that a Boolean(0) is false...
				if (val.toString()) {
					val = typeof val === "number" ? val : this.defaultCount;
					if (typeof val === "number") {
						val = clamp(val, this.min, this.max);
					}
				}
				this.$emit("input", val);
			},
		},
	},
	methods: {
		stepperMiddleware(val) {
			// Empty strings should be allowed to bubble upwards.
			if (!val.toString()) {
				return val;
			}

			val = parseInt(val);
			if (isNaN(val)) {
				return this.defaultCount;
			}

			val = clamp(val, this.min, this.max);
			return val;
		},
		onDecreaseStepperCountClick() {
			this._stepperCount -= 1;
		},
		onIncreaseStepperCountClick() {
			this._stepperCount += 1;
		},
		onStepperCountInputChanged(e) {
			if (e?.target?.value) {
				return;
			}

			// If there is no value, we set it to the default one
			this._stepperCount = this.defaultCount;
		},
	},
};
